import React, { Component } from "react";

class ProjManagementContent extends Component {
  render() {
    return (
      <div>
        <table
          className="table border-bottom"
          style={{ margin: "auto", align: "center" }}
        >
          <thead style={{ background: "#2fa9e9" }}>
            <tr>
              {this.props.data["header"].map((key) => (
                <th
                  style={{ verticalAlign: "middle", textAlign: "center" }}
                  key={key}
                  scope="col"
                >
                  {key}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {Object.keys(this.props.data["rows"]).map((item, key) => (
              <tr key={key}>
                {this.props.data["rows"][item].map((item1, key1) => {
                  {/* if (item1.search("Resigned") !== -1) {
                    return (
                      <td key={key1} style={{ color: "red" }}>
                        {item1}
                      </td>
                    );
                  } else if (item1.search("25-July-2018") !== -1) {
                    return (
                      <td key={key1} style={{ color: "red" }}>
                        {item1}
                      </td>
                    );
                  } else { */}
                     
                    return <td key={key1} >{item1}</td>;
                  {/* } */}
                })}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  }
}

export default ProjManagementContent;
